import React from "react";

import { CheckRounded, InfoRounded, WarningRounded } from "@mui/icons-material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, DialogContent } from "@mui/material";

import MainBorderButton from "../MainBorderButton";
import MainSolidButton from "../MainSolidButton";
import MainText from "../MainText";
import { ModalTransition } from "../ModalTransition";
import PageHeader from "../PageHeader";

import { ModalType } from "../../types/common";
import { WideDialog } from "./styles";

export default function MainModalSimple({
  title,
  children,
  message,
  type = "default",
  isClosable,
  isConfirm,
  onClose,
  onConfirm,
  onDimiss,
}: ModalType) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  const handleConfirm = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
      if (onConfirm) onConfirm();
    }, 200);
  };

  return (
    <WideDialog
      maxWidth={false}
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={title ?? ""}
          rightIcon={isClosable ? <CloseRoundedIcon /> : undefined}
          onRightAction={isClosable ? handleClose : undefined}
        />

        {type === "delete" && (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mr={message ? 2 : 0}>
              <WarningRounded />
            </Box>

            <MainText color="regular" size="body">
              Deseja realmente deletar?
            </MainText>
          </Box>
        )}

        {type === "error" && (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mr={message ? 2 : 0}>
              <WarningRounded color="error" />
            </Box>

            <MainText color="regular" size="body">
              {message}
            </MainText>
          </Box>
        )}

        {type === "info" && (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mr={message ? 2 : 0}>
              <InfoRounded color="secondary" />
            </Box>
            <MainText color="regular" size="body">
              {message}
            </MainText>
          </Box>
        )}

        {type === "success" && (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mr={message ? 2 : 0}>
              <CheckRounded color="success" />
            </Box>
            <MainText color="regular" size="body">
              {message}
            </MainText>
          </Box>
        )}

        {type === "warning" && (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box mr={message ? 2 : 0}>
              <WarningRounded color="warning" />
            </Box>
            <MainText color="regular" size="body">
              {message}
            </MainText>
          </Box>
        )}

        {typeof children !== "function"
          ? children
          : typeof children === "function"
          ? children(handleClose)
          : null}

        {isConfirm || type === "delete" ? (
          <Box mt={2}>
            <MainBorderButton
              text={"Cancelar"}
              onClick={() => {
                onDimiss?.();
                handleClose();
              }}
            />

            <Box mt={2}>
              <MainSolidButton
                color={type === "delete" ? "danger" : "black"}
                onClick={handleConfirm}
                text={type === "delete" ? "Deletar" : "OK"}
              />
            </Box>
          </Box>
        ) : type !== "default" ? (
          <Box mt={2}>
            <MainSolidButton onClick={handleClose} text={"OK"} />
          </Box>
        ) : null}
      </DialogContent>
    </WideDialog>
  );
}
